import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=ae43098e&scoped=true&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=ae43098e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae43098e",
  null
  
)

export default component.exports